import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import FeaturedVideos from './components/FeaturedVideos';
import LatestVideos from './components/LatestVideos';
import TrendingArticles from './components/TrendingArticles';

export default function Home() {
  const { t } = useTranslation();

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91视频网站',
    url: 'https://www.91video.com',
    description: '91视频网站是一个提供海量高清视频内容的在线观看平台，涵盖热门影视、短视频、综艺娱乐等多种类型。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-9191',
      contactType: 'customer service',
      email: 'contact@91video.com',
      availableLanguage: 'Chinese',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '91视频网站',
    url: 'https://www.91video.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.91video.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>

      <Navbar />
      <main>
        <HeroBanner />
        <CategorySection />
        <FeaturedVideos />
        <LatestVideos />
        <TrendingArticles />
      </main>
      <Footer />
    </>
  );
}